export const simpleProductVariantName = 'Default'

export const productImageNames = {
  image: 'image'
}

export const cardProductPurposes = {
  general: 'general',
  affiliate: 'affiliate',
  flashsale: 'flashsale',
  addCart: 'add-cart'
}

export const productTypes = {
  simple: 'simple',
  combination: 'combination'
}

export const variantNames = {
  default: {
    name: 'Default',
    value: 'default'
  }
}

export const splitProductPrice = (price) => {
  if (!price) {
    return ['0']
  }

  return price.toString().split('-', 2)
    .map(price => Number(price))
}

export const isOriginalPriceAndDiscountedPriceEqual = (product) => {
  return product.price === product.discounted_price
}

export const getProductDetailFromSelectedVariantNames = (
  details = [],
  variantNames = [],
  productType = productTypes.simple
) => {
  if (!Array.isArray(details) || details.length === 0) { return null }

  switch (productType) {
    case productTypes.simple:
      return details[0]

    case productTypes.combination: {
      return details.find((detail) => {
        const names = detail.name.split(',').map(name => name.trim())
        return variantNames.every(variantName => names.includes(variantName))
      }) || null
    }

    default:
      return null
  }
}

export const isVariantDisabled = (
  itemVarName,
  indexVariantCat,
  selected = [],
  details = [],
  productType = productTypes.simple
) => {
  if (productType !== productTypes.combination) {
    return false
  }

  // If the variant is currently selected, don't disable it so it can be unselected
  if (selected[indexVariantCat] === itemVarName) {
    return false
  }

  const hypotheticalSelected = [...selected]
  hypotheticalSelected[indexVariantCat] = itemVarName

  const isAnyAvailable = details.some((detail) => {
    const detailNames = detail.name.split(',').map(name => name.trim())

    const isMatch = hypotheticalSelected.every((select) => {
      return select === '' || detailNames.includes(select)
    })

    return isMatch && detail.stock > 0
  })

  return !isAnyAvailable
}
